import { render, staticRenderFns } from "./InvestorItem.vue?vue&type=template&id=337daeb8&scoped=true&"
import script from "./InvestorItem.vue?vue&type=script&lang=js&"
export * from "./InvestorItem.vue?vue&type=script&lang=js&"
import style0 from "./InvestorItem.vue?vue&type=style&index=0&id=337daeb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337daeb8",
  null
  
)

export default component.exports